import { render, staticRenderFns } from "./ReporteVentasPorLibro.vue?vue&type=template&id=335f74b9"
import script from "./ReporteVentasPorLibro.vue?vue&type=script&lang=js"
export * from "./ReporteVentasPorLibro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports